export enum TypeOfUberRideEnum {
  Normal,
  Flexible,
};

export interface IUberPayload {
  TypeOfUberRide?: TypeOfUberRideEnum;
};



// WEBPACK FOOTER //
// ./src/app/core/enums/uber.enum.ts